import { useId } from "react";
import { Input } from "@omnabase/ui";
import { FORM_LIMITS, FORM_TEXT_DEFAULTS, FORM_TEXT_KEYS, type FormTextKey, type FormTexts } from "@omnabase/shared";

/** "Texts" (the form editor round, the brief's item 4 and question 9): the form's own words for the button, the busy button, the thank-you
 *  line, the error line and the line under an empty required field, each at most 200 characters. An empty box keeps the default words, shown
 *  as its placeholder (English until a language setting exists, question 10). The page, the embed and the preview read them. */
const LABELS: Record<FormTextKey, string> = { submit: "Submit button", sending: "Button while sending", success: "Thank-you line", error: "Error line", required: "Under an empty required field" };

export function FormTextsSection({ texts, edit, onText }: { texts: FormTexts; edit: boolean; onText: (key: FormTextKey, value: string) => void }) {
  return (
    <div className="ob-form-builder__row-settings">
      <p className="ob-form-builder__hint">The words visitors see; an empty box keeps the default.</p>
      {FORM_TEXT_KEYS.map((k) => <TextBox key={k} label={LABELS[k]} value={texts[k]} placeholder={FORM_TEXT_DEFAULTS[k]} edit={edit} onChange={(v) => onText(k, v)} />)}
    </div>
  );
}

function TextBox({ label, value, placeholder, edit, onChange }: { label: string; value: string; placeholder: string; edit: boolean; onChange: (v: string) => void }) {
  const id = useId();
  return (
    <div className="ob-form-builder__setting">
      <label className="ob-field-label" htmlFor={id}>{label}</label>
      <Input id={id} className="ob-input--text" value={value} placeholder={placeholder} maxLength={FORM_LIMITS.text} disabled={!edit} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}
